var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 116,
    viewBox: "0 0 163 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9906_54512)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.4,
    height: 116,
    rx: 14.16,
    fill: "#DBF5B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 42.1932,
    width: 132.733,
    height: 30.4667,
    rx: 7.53973,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 42.1932,
    width: 132.733,
    height: 30.4667,
    rx: 7.53973,
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9906_54512)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 22,
    transform: "translate(-0.299805 0.5)",
    fill: "#A9E079"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8596,
    cy: 11.5134,
    r: 3.14667,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.8727,
    cy: 11.5134,
    r: 3.14667,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.8864,
    cy: 11.5134,
    r: 3.14667,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.133,
    y: 8.8667,
    width: 30.4667,
    height: 5.29333,
    rx: 2.64667,
    fill: "white",
    stroke: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9906_54512)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.7002,
    y: 50.3466,
    width: 50.3467,
    height: 50.3467,
    rx: 11.8,
    fill: "#A9E079"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2002,
    y: 50.8466,
    width: 49.3467,
    height: 49.3467,
    rx: 11.3,
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7463 86.5334C68.2844 86.5334 67.9317 86.3195 67.6884 85.8916C67.4441 85.4638 67.4374 85.036 67.6684 84.6081L79.7954 62.7885C80.0264 62.3606 80.3857 62.1467 80.8733 62.1467C81.361 62.1467 81.7203 62.3606 81.9513 62.7885L94.0783 84.6081C94.3093 85.036 94.3026 85.4638 94.0583 85.8916C93.815 86.3195 93.4623 86.5334 93.0003 86.5334H68.7463ZM80.8733 71.0912C80.6423 71.0912 80.456 71.1714 80.3143 71.3318C80.1737 71.4923 80.1034 71.6795 80.1034 71.8934V78.3109C80.1034 78.5516 80.1804 78.7457 80.3344 78.8933C80.4883 79.0398 80.668 79.1131 80.8733 79.1131C81.1043 79.1131 81.2907 79.0398 81.4323 78.8933C81.573 78.7457 81.6433 78.5516 81.6433 78.3109V71.8934C81.6433 71.6795 81.5663 71.4923 81.4123 71.3318C81.2583 71.1714 81.0787 71.0912 80.8733 71.0912ZM80.8733 82.723C81.13 82.723 81.3548 82.623 81.5478 82.423C81.7398 82.2219 81.8358 81.9876 81.8358 81.7202C81.8358 81.4528 81.7398 81.2186 81.5478 81.0175C81.3548 80.8175 81.13 80.7175 80.8733 80.7175C80.6167 80.7175 80.3918 80.8175 80.1988 81.0175C80.0069 81.2186 79.9109 81.4528 79.9109 81.7202C79.9109 81.9876 80.0069 82.2219 80.1988 82.423C80.3918 82.623 80.6167 82.723 80.8733 82.723ZM69.2468 84.929H92.4999L80.8733 64.072L69.2468 84.929Z",
    fill: "#1C1B1F"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161.4,
    height: 115,
    rx: 13.66,
    stroke: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9906_54512",
    x: -0.299805,
    y: 0.5,
    width: 163,
    height: 23.9667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.96667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9906_54512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9906_54512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9906_54512",
    x: 55.7002,
    y: 50.3466,
    width: 50.3467,
    height: 52.3133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.96667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9906_54512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9906_54512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9906_54512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.4,
    height: 116,
    rx: 14.16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound404);
export default __webpack_public_path__ + "static/media/not-found-404.138a311edd2a07fbee27ac3c5d91fc39.svg";
export { ForwardRef as ReactComponent };